import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { KEOForwardedDto, RecordCardService } from "../../../../../api";
import { AlertService, MessageType } from "../../../services/alert.service";

@UntilDestroy()
@Component({
  selector: "app-filed-forwarded-waste-transfer-cards",
  templateUrl: "./filed-forwarded-waste-transfer-cards.component.html",
  styleUrls: ["./filed-forwarded-waste-transfer-cards.component.scss"],
})
export class FiledForwardedWasteTransferCardsComponent implements OnInit {
  public details: KEOForwardedDto;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  loading = false;
  constructor(public dialogRef: MatDialogRef<FiledForwardedWasteTransferCardsComponent>, private service: RecordCardService, @Inject(MAT_DIALOG_DATA) public data: { cardId: string }, private alertService: AlertService) {}

  load() {
    this.loading = true;
    this.service.getKEOForwardedList(this.data.cardId, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(
      (result) => {
        this.details = result;
        console.log(this.details);
        this.paginator.length = result.forwardedForwardedKeos.totalResultNumber;
      },
      (error) => this.alertService.showMessage(error, MessageType.Error),
      () => (this.loading = false)
    );
  }

  ngOnInit(): void {
    this.load();
    this.paginator.page.pipe(untilDestroyed(this)).subscribe((p) => this.load());
  }
}
